import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { EmploymentGridItemObject } from '@libs/types/src/user/object-type/employment-grid.object';

@Injectable()
export class UserEmploymentsStore extends ComponentStoreV2Factory {
    public employments = computed(() => {
        const grid = this.data.getEmployments();
        if (!grid) {
            return null;
        }

        const items = (grid.items || [])
            .map((it: EmploymentGridItemObject) => {
                const canEdit = this.isAllowedForService('user.update', it.serviceId)();

                return {
                    ...it,
                    __hideDetail: !canEdit,
                    __hideDelete: !canEdit,
                };
            })
        ;

        return {
            ...grid,
            items,
        }
    });
}
